import { Fragment } from 'react';
import { Table, Text, Stack } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';

export interface ResponsiveTableProps {
  headers: string[] | JSX.Element[];
  tableData: (string | JSX.Element)[][];
  sectionId: string;
  tableTitle?: string;
}

export const ResponsiveTable: React.FC<ResponsiveTableProps> = ({
  headers,
  tableData,
  sectionId,
  tableTitle,
}) => {
  const { isMobile } = useScreenSize();
  const mobileTableHeaders = headers.slice(1, headers.length);

  const desktopView = (
    <Table
      sectionId={`${sectionId}-table`}
      className="styleless-header striped"
      headers={headers}
      rows={tableData}
      sx={{
        '.MuiTableCell-root': {
          p: 0,
        },
      }}
    />
  );

  const mobileView = (
    <Stack spacing={1} data-testid={`${sectionId}-stack`}>
      {tableData.map((row, index) => {
        const rowData = row.slice(1, row.length).map((cell, index) => {
          return [mobileTableHeaders[index], cell];
        });
        return (
          <Fragment key={index}>
            <Text
              variant="h5"
              sx={{
                '&.MuiTypography-root': {
                  m: '0.875rem 0 0 0',
                },
              }}
            >
              {row[0]}
            </Text>
            <Table
              className="striped"
              rows={rowData}
              sx={{
                '.MuiTableCell-root': {
                  width: '50%',
                },
              }}
            />
          </Fragment>
        );
      })}
    </Stack>
  );

  return (
    <>
      {tableTitle && (
        <Text variant="h3" data-testid={`${sectionId}-title`}>
          {tableTitle}
        </Text>
      )}
      {Boolean(tableData.length) && !isMobile && desktopView}
      {tableData.length && isMobile && mobileView}
    </>
  );
};
